import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center justify-center min-h-screen sm:pt-4 px-4 sm:pb-20 text-center sm:block sm:p-0" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", {
    class: "hidden sm:inline-block sm:align-middle sm:h-screen",
    "aria-hidden": "true"
}, "​", -1);
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" };
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" };
const _hoisted_5 = { class: "sm:flex sm:items-start" };
const _hoisted_6 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_7 = { class: "mt-2" };
const _hoisted_8 = { class: "text-sm text-gray-500" };
const _hoisted_9 = { class: "text-sm text-gray-500" };
const _hoisted_10 = {
    key: 0,
    class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogOverlay = _resolveComponent("DialogOverlay");
    const _component_TransitionChild = _resolveComponent("TransitionChild");
    const _component_information_circle_icon = _resolveComponent("information-circle-icon");
    const _component_check_circle_icon = _resolveComponent("check-circle-icon");
    const _component_exclamation_icon = _resolveComponent("exclamation-icon");
    const _component_DialogTitle = _resolveComponent("DialogTitle");
    const _component_Dialog = _resolveComponent("Dialog");
    const _component_TransitionRoot = _resolveComponent("TransitionRoot");
    return (_openBlock(), _createBlock(_component_TransitionRoot, {
        as: "template",
        show: true
    }, {
        default: _withCtx(() => [
            _createVNode(_component_Dialog, {
                as: "div",
                class: "fixed z-10 inset-0 overflow-y-auto",
                onClose: _ctx.close
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_TransitionChild, {
                            as: "template",
                            enter: "ease-out duration-300",
                            "enter-from": "opacity-0",
                            "enter-to": "opacity-100",
                            leave: "ease-in duration-200",
                            "leave-from": "opacity-100",
                            "leave-to": "opacity-0"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                            ]),
                            _: 1
                        }),
                        _hoisted_2,
                        _createVNode(_component_TransitionChild, {
                            as: "template",
                            enter: "ease-out duration-300",
                            "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                            "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass([{
                                                        'bg-red-100': _ctx.type === 'warning',
                                                        'bg-green-100': _ctx.type === 'success',
                                                        'bg-blue-100': _ctx.type === 'info',
                                                    }, "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10"])
                                            }, [
                                                (_ctx.type === 'info')
                                                    ? (_openBlock(), _createBlock(_component_information_circle_icon, {
                                                        key: 0,
                                                        class: "h-6 w-6 text-blue-600",
                                                        "aria-hidden": "true"
                                                    }))
                                                    : (_ctx.type === 'success')
                                                        ? (_openBlock(), _createBlock(_component_check_circle_icon, {
                                                            key: 1,
                                                            class: "h-6 w-6 text-green-600",
                                                            "aria-hidden": "true"
                                                        }))
                                                        : (_openBlock(), _createBlock(_component_exclamation_icon, {
                                                            key: 2,
                                                            class: "h-6 w-6 text-red-600",
                                                            "aria-hidden": "true"
                                                        }))
                                            ], 2),
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(_component_DialogTitle, {
                                                    as: "h3",
                                                    class: "text-lg leading-6 font-medium text-gray-900"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _renderSlot(_ctx.$slots, "header")
                                                    ]),
                                                    _: 3
                                                }),
                                                _createElementVNode("div", _hoisted_7, [
                                                    _createElementVNode("p", _hoisted_8, [
                                                        _renderSlot(_ctx.$slots, "content")
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_9, [
                                                    _renderSlot(_ctx.$slots, "default")
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (_ctx.$slots.actions)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _renderSlot(_ctx.$slots, "actions")
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _: 3
                        })
                    ])
                ]),
                _: 3
            }, 8, ["onClose"])
        ]),
        _: 3
    }));
}
